<!-- Breadcrumb Section -->
<div class="bg-header" *ngIf="configurationService.isTabletOrLarger$ | async">
  <div class="container-header">
    <h1 routeDirective>
      {{ 'competitionModule.competitions' | translate }}
    </h1>
  </div>
</div>
<!-- End Breadcrumb Section -->

<div class="container-lg main-container">
  <!-- Card -->

  <!-- SELECT YOUR TEAM -->
  <ng-container>
    <label class="form-label" id="selectTeamsLabel">
      {{ 'competitionModule.selectYourTeam' | translate }}
      <span class="small" [hidden]="showOnlyCompetitionStanding"
        >({{ 'competitionModule.captainCanEditTeams' | translate }})</span
      >
    </label>

    <div class="mb-4">
      <div
        class="spinner-border"
        role="status"
        *ngIf="isLoading$ | async"
        attr.aria-label="{{ 'wcag.loading' | translate }}"
      ></div>
      <div *ngIf="!(isLoading$ | async)">
        <select
          class="form-select"
          (change)="onSelectTeam($event)"
          aria-labelledby="selectTeamsLabel"
        >
          <option [ngValue]="null" selected>
            {{ 'general.select' | translate }}
          </option>
          <option *ngFor="let team of teams$ | async" [value]="team.id">
            {{ team.description }} -
            {{
              (competitionEntities$ | async)[team.competitionId]?.description
            }}
          </option>
        </select>
      </div>
    </div>
  </ng-container>

  <!-- SELECT Competitions -->
  <ng-container>
    <label class="form-label" id="competitionLabel">
      {{ 'competitionModule.selectCompetition' | translate }}
    </label>

    <div class="mb-4">
      <div
        class="spinner-border"
        role="status"
        *ngIf="isLoading$ | async"
        attr.aria-label="{{ 'wcag.loading' | translate }}"
      ></div>
      <div *ngIf="!(isLoading$ | async)">
        <select
          class="form-select"
          (change)="onSelectCompetition($event)"
          aria-labelledby="competitionLabel"
        >
          <option [ngValue]="null" selected>
            {{ 'general.select' | translate }}
          </option>
          <option
            *ngFor="let competition of competitions$ | async"
            [value]="competition.id"
          >
            {{ competition.description }}
          </option>
        </select>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!showOnlyCompetitionStanding">
    <p class="text-center">{{ 'general.or' | translate }}</p>
    <div class="text-center">
      <button
        class="btn btn-primary"
        (click)="onClickCreateTeam()"
        type="button"
      >
        {{ 'competitionModule.createNewTeam' | translate }}
      </button>
    </div>
  </ng-container>
</div>

<router-outlet></router-outlet>
